import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights, DistributedTracingModes } from '@microsoft/applicationinsights-web';
import { appConfig } from './AppConfig';

const reactPlugin = new ReactPlugin();
const connectionString = appConfig.APP_INSIGHTS_CONNECTION_STRING;

const appInsights = new ApplicationInsights({
    config: {
        connectionString: connectionString,
        enableAutoRouteTracking: true,
        // extensions: [reactPlugin],
        // distributedTracingMode: DistributedTracingModes.W3C,
        // enableCorsCorrelation: true,
    },
});

if (connectionString && connectionString.length) {
    appInsights.loadAppInsights();
}

export { appInsights, reactPlugin };
